import { mapCollection } from '../../utils/collection.utils';
import { Historical } from '../historical';

export class HistoricalBuilder {
  static fromJson(json) {
    return (json)
      ? new Historical(
        json.categoryTitle,
        json.historicalPollsResponses
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(HistoricalBuilder.fromJson, list) : [];
  }
}
